export const roles = [
   { type: 'Person', kind: 'Member', roles: ['Create', 'Read', 'Update', 'Delete'] },
   { type: 'Person', kind: 'Receptionist', roles: ['Create', 'Read', 'Update', 'Delete', 'Export', 'Import'] },
   { type: 'Location', kind: 'Building', roles: ['Create', 'Read', 'Update', 'Delete', 'Export', 'Import'] },
   { type: 'Location', kind: 'Floor', roles: ['Create', 'Read', 'Update', 'Delete', 'Export', 'Import'] },
   { type: 'Subject', kind: 'Organization', roles: ['Create', 'Read', 'Update', 'Delete', 'Export', 'Import'] },
   { type: 'Subject', kind: 'Device', roles: ['Create', 'Read', 'Update', 'Delete'] },
   { type: 'Activity', kind: 'Registration', roles: ['Read', 'Update', 'Delete'] },
   { type: 'Activity', kind: 'Enrollment', roles: ['Read', 'Update', 'Delete'] },
   { type: 'Activity', kind: 'Approval', roles: ['Read', 'Update', 'Delete'] },
   { type: 'Option', kind: 'Profile', roles: ['Read', 'Update'] },
   { type: 'Option', kind: 'Setting', roles: ['Read'] },
   { type: 'Option', kind: 'Management', roles: ['Create', 'Read', 'Update', 'Delete'] },
   { type: 'Option', kind: 'Actor', roles: ['Create', 'Read', 'Update', 'Delete', 'Export', 'Import'] },
   { type: 'Option', kind: 'Notification', roles: ['Create', 'Read', 'Update', 'Delete'] },
   { type: 'Option', kind: 'Roles', roles: ['Create', 'Read', 'Update', 'Delete'] },
   { type: 'Option', kind: 'Sequence', roles: ['Create', 'Read', 'Update', 'Delete'] },
   { type: 'Option', kind: 'Dashboard', roles: ['Read'] },
   { type: 'Option', kind: 'Report', roles: ['Read'] },
]